/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsIdMembersMutationRequest,
  PostTeamsIdMembersMutationResponse,
  PostTeamsIdMembersPathParams,
  PostTeamsIdMembers400,
  PostTeamsIdMembers401,
  PostTeamsIdMembers403,
  PostTeamsIdMembers500,
} from "../types/PostTeamsIdMembers.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsIdMembersMutationKey = () =>
  [{ url: "/teams/:id/members" }] as const;

export type PostTeamsIdMembersMutationKey = ReturnType<
  typeof postTeamsIdMembersMutationKey
>;

/**
 * @description Участнику отправляется уведомление о приглашении.
 * Приглашение необходимо принять через /team-invitations/{id}/accept.
 * @summary Приглашение участника в команду
 * {@link /teams/:id/members}
 */
export async function postTeamsIdMembers(
  id: PostTeamsIdMembersPathParams["id"],
  data: PostTeamsIdMembersMutationRequest,
  config: Partial<RequestConfig<PostTeamsIdMembersMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostTeamsIdMembersMutationResponse,
    ResponseErrorConfig<
      | PostTeamsIdMembers400
      | PostTeamsIdMembers401
      | PostTeamsIdMembers403
      | PostTeamsIdMembers500
    >,
    PostTeamsIdMembersMutationRequest
  >({
    method: "POST",
    url: `/teams/${id}/members`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function postTeamsIdMembersMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostTeamsIdMembersMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postTeamsIdMembersMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsIdMembersMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdMembers400
      | PostTeamsIdMembers401
      | PostTeamsIdMembers403
      | PostTeamsIdMembers500
    >,
    {
      id: PostTeamsIdMembersPathParams["id"];
      data: PostTeamsIdMembersMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return postTeamsIdMembers(id, data, config);
    },
  });
}

/**
 * @description Участнику отправляется уведомление о приглашении.
 * Приглашение необходимо принять через /team-invitations/{id}/accept.
 * @summary Приглашение участника в команду
 * {@link /teams/:id/members}
 */
export function usePostTeamsIdMembers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsIdMembersMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsIdMembers400
        | PostTeamsIdMembers401
        | PostTeamsIdMembers403
        | PostTeamsIdMembers500
      >,
      {
        id: PostTeamsIdMembersPathParams["id"];
        data: PostTeamsIdMembersMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostTeamsIdMembersMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTeamsIdMembersMutationKey();

  const baseOptions = postTeamsIdMembersMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsIdMembersMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdMembers400
      | PostTeamsIdMembers401
      | PostTeamsIdMembers403
      | PostTeamsIdMembers500
    >,
    {
      id: PostTeamsIdMembersPathParams["id"];
      data: PostTeamsIdMembersMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsIdMembersMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdMembers400
      | PostTeamsIdMembers401
      | PostTeamsIdMembers403
      | PostTeamsIdMembers500
    >,
    {
      id: PostTeamsIdMembersPathParams["id"];
      data: PostTeamsIdMembersMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsIdMembersMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsIdMembers400
      | PostTeamsIdMembers401
      | PostTeamsIdMembers403
      | PostTeamsIdMembers500
    >,
    {
      id: PostTeamsIdMembersPathParams["id"];
      data: PostTeamsIdMembersMutationRequest;
    },
    TContext
  >;
}
